interface IClusterInitialState {
  // runFrom: {
  filters: { [key: string]: string };
  // }
}
export const clusterState: IClusterInitialState = {
  // appIds: [],
  filters: {},
};
